import ButtonIconPicker from 'client/components/core/Sidebar/components/Settings/components/ButtonIconPicker'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React from 'react'
import { SidebarBottomPortal } from 'src/editor/layout/sidebar/settings/sidebar-bottom-portal'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import {
  FormInterface,
  FormSubEntityTypeEnum,
  FormSubmitButtonInterface,
} from 'src/shared/types/entities/form-interface'
import { useUpdateFormSubEntityProp } from '../../hooks/use-update-form-sub-entity-prop'
import { FormSubEntityCommonSettingsButtonLink } from './form-sub-entity-common-settings-button-link'

export interface FormSubmitButtonSubEntitySettingsProps {
  formEntity: FormInterface
  submitButtonSubEntity: FormSubmitButtonInterface
}

export const FormSubmitButtonSubEntitySettings = ({
  formEntity,
  submitButtonSubEntity,
}: FormSubmitButtonSubEntitySettingsProps) => {
  const { t } = useTypedTranslation()

  const updateProp = useUpdateFormSubEntityProp(
    formEntity,
    submitButtonSubEntity,
  )

  return (
    <>
      <TextInputControl
        wrapperProps={{
          labelText: t('entity_settings.button.button_text.label'),
        }}
        value={submitButtonSubEntity.text}
        update={updateProp('text')}
      />
      <TextInputControl
        wrapperProps={{
          labelText: 'entity_settings.button.sub_text.label',
        }}
        update={updateProp('subText')}
        value={submitButtonSubEntity.subText}
      />
      <ButtonIconPicker
        valueBefore={submitButtonSubEntity.iconClassNameBefore}
        valueAfter={submitButtonSubEntity.iconClassNameAfter}
        updateBefore={updateProp('iconClassNameBefore')}
        updateAfter={updateProp('iconClassNameAfter')}
      />
      <HtmlAttrId attrId={submitButtonSubEntity.htmlAttrId} />

      <SidebarBottomPortal>
        <FormSubEntityCommonSettingsButtonLink
          formEntity={formEntity}
          commonSettingsType={FormSubEntityTypeEnum.SubmitButton}
        />
      </SidebarBottomPortal>
    </>
  )
}
